const TERMINALS_TYPES = {
  TELESALES: "TLS",
  SHOWROOM: "SHR",
  ONLINE: "ONL",
  SOCIAL: "SCA",
  AGENT: "AGE"
};

export { TERMINALS_TYPES };
